"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');




var _AccountPage = require('./AccountPage'); var _AccountPage2 = _interopRequireDefault(_AccountPage);










const AccountPageRoute = ({ accountFor, ...props }) => {
  const { orgKey, tabName = null } = _reactrouterdom.useRouteMatch().params

  return _react2.default.createElement(_AccountPage2.default, { ...props, account: accountFor(orgKey), routeOrgKey: orgKey, tabName: tabName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}} )
}

exports. default = AccountPageRoute
